// extracted by mini-css-extract-plugin
export var avatarContainer = "_fz-0";
export var avatarTypingWave = "_fz-i";
export var gray = "_fz-f";
export var green = "_fz-c";
export var icon = "_fz-9";
export var image = "_fz-1";
export var lg = "_fz-6";
export var md = "_fz-5";
export var presenceDot = "_fz-b";
export var red = "_fz-d";
export var sm = "_fz-4";
export var status = "_fz-a";
export var typingDot = "_fz-h";
export var typingPill = "_fz-g";
export var xl = "_fz-7";
export var xs = "_fz-3";
export var xxl = "_fz-8";
export var xxs = "_fz-2";
export var yellow = "_fz-e";